import { useAuth } from "../../context/auth-context";
import type {
  AdminGiftcardSummariesData,
  AdminGiftcardSummariesEnvelope,
} from "./adminGiftcardSummaries";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

export type UseAdminGiftcardSummariesParams = {
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
};

/**
 * GET api/admin/transactions/summaries?type=giftcard[&startDate][&endDate]
 */
export function useAdminGiftcardSummariesQuery(
  params: UseAdminGiftcardSummariesParams = {}
) {
  const { isAuthenticated } = useAuth();
  const { startDate, endDate, enabled: enabledParam = true } = params;

  return useApiQuery<
    AdminGiftcardSummariesEnvelope,
    AdminGiftcardSummariesData
  >({
    queryKey: apiQueryKey("admin-transactions-summaries", {
      type: "giftcard",
      startDate: startDate ?? null,
      endDate: endDate ?? null,
    }),
    url: "api/admin/transactions/summaries",
    params: {
      type: "giftcard",
      startDate,
      endDate,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
